"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = void 0;
var web_track_browser_1 = __importDefault(require("@aliyun-sls/web-track-browser"));
var hosts_1 = require("./hosts");
var logger_1 = require("../types/logger");
var utils_1 = require("../utils/utils");
var stringify_1 = __importDefault(require("./stringify"));
var constant_1 = require("../constant");
var connection_1 = require("../utils/connection");
var base_log_1 = require("../downgrade/base-log");
/**
 * logger 基类
 */
var Logger = /** @class */ (function () {
    function Logger(t, ns, extend) {
        var _this = this;
        var _a;
        // logger 的命名空间
        Object.defineProperty(this, "ns", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "slsTracker", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "topic", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "source", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "transports", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "cacheTo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/];
                });
            }); }
        });
        Object.defineProperty(this, "delayedSend", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/];
                });
            }); }
        });
        Object.defineProperty(this, "isDowngrade", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: connection_1.isDowngrade
        });
        // 初始化的时候检查一遍 uuid，如果没有的话生成一个
        if (!Logger._uuid) {
            Logger._uuid = Logger._generateUUID();
            // 环境相关的判断, 只在第一次进入应用的时候计算
            if (extend === null || extend === void 0 ? void 0 : extend.environment) {
                Logger.currentEnv =
                    (extend === null || extend === void 0 ? void 0 : extend.environment) === "prod" ? "production" : extend === null || extend === void 0 ? void 0 : extend.environment;
            }
            else {
                // 不传环境参数的兜底逻辑
                var _b = (0, hosts_1.hostCheck)(location.host), isTest = _b.isTest, isPre = _b.isPre, isLocal = _b.isLocal;
                if (isLocal) {
                    Logger.currentEnv = "local";
                }
                else if (isTest) {
                    Logger.currentEnv = "test";
                }
                else if (isPre) {
                    Logger.currentEnv = "pre";
                }
            }
            // 本地环境：输出到控制台，落到 IndexedDB，不写 SLS
            // 生产环境：不输出到控制台，落到 IndexedDB，写 SLS
            // 测试 / 预发环境：输出到控制台，落到 IndexedDB，写 SLS
            if (Logger.currentEnv !== "production") {
                Logger._shouldLogToConsole = true;
            }
            // 有些项目是local dev mock ,dev mock 也认为是本地
            if (Logger.currentEnv !== "local" && Logger.currentEnv !== "dev" && Logger.currentEnv !== "mock") {
                Logger._shouldLogToSls = true;
            }
            // 根据 transports 区分是否写 indexDB
            if (window.indexedDB && ((_a = extend === null || extend === void 0 ? void 0 : extend.transports) === null || _a === void 0 ? void 0 : _a.includes("indexDB"))) {
                Logger._shouldLogToIndexedDB = true;
            }
        }
        var _c = extend || {}, cacheTo = _c.cacheTo, delayedSend = _c.delayedSend, source = _c.source, tags = _c.tags, transports = _c.transports;
        this.topic = t || "";
        this.source = source || "";
        this.tags = tags || {};
        this.transports = transports || [];
        if (cacheTo) {
            this.cacheTo = cacheTo;
        }
        if (delayedSend) {
            this.delayedSend = delayedSend;
        }
        var slsLogProject = ["local", "test", 'sit', 'mock', 'dev'].includes(Logger.currentEnv)
            ? constant_1.slsConfig.test.logProject
            : constant_1.slsConfig.production.logProject;
        var slsLogStore = ["local", "test", 'sit', 'mock', 'dev'].includes(Logger.currentEnv)
            ? constant_1.slsConfig.test.logStore
            : constant_1.slsConfig.production.logStore;
        var slsOptions = {
            host: constant_1.SLS_HOST,
            // SLS Project 名称
            project: slsLogProject,
            // SLS Log Store 名称
            logstore: slsLogStore,
            // 发送日志的时间间隔，不设置默认是10秒。
            time: (extend === null || extend === void 0 ? void 0 : extend.delayTimes) || 5,
            // 发送日志的数量大小，默认是10条。
            count: 10,
            // 自定义日志主题。
            topic: this.topic,
            source: this.source,
            tags: this.tags,
        };
        this.ns = ns || "default";
        try {
            this.slsTracker = new web_track_browser_1.default(slsOptions);
        }
        catch (error) {
            this.slsTracker = {
                send: function () {
                },
            };
            console.error(error);
        }
    }
    /**
     * 生成 UUID
     * @returns
     */
    Object.defineProperty(Logger, "_generateUUID", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            // implementation of UUID generation
            return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
                var r = (Math.random() * 16) | 0;
                var v = c === "x" ? r : (r & 0x3) | 0x8;
                return v.toString(16);
            });
        }
    });
    /**
     * 生成格式化后的时间 格式:YYYY-MM-DD HH:mm:ss
     * @returns
     */
    Object.defineProperty(Logger, "_getFormattedTime", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (date) {
            var d = date ? new Date(date) : new Date();
            var year = d.getFullYear();
            var month = "".concat(d.getMonth() + 1).padStart(2, "0");
            var day = "".concat(d.getDate()).padStart(2, "0");
            var hour = "".concat(d.getHours()).padStart(2, "0");
            var minute = "".concat(d.getMinutes()).padStart(2, "0");
            var second = "".concat(d.getSeconds()).padStart(2, "0");
            return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hour, ":").concat(minute, ":").concat(second);
        }
    });
    /**
     * 检查日志等级是否启用
     * @param level 日志等级
     * @returns 日志等级是否可用
     */
    Object.defineProperty(Logger, "_checkIfLogLevelEnabled", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (level) {
            return (Logger._logLevels.indexOf(level) >=
                Logger._logLevels.indexOf(Logger.level));
        }
    });
    /**
     * 将任何类型的变量转换为字符串以便用于远程日志
     * @param param
     * @returns
     */
    Object.defineProperty(Logger.prototype, "_toString", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (param) {
            var type = typeof param;
            var output = "";
            if (param instanceof Error) {
                output = "[Error] ".concat(param.message);
                // Add stack trace if available
                if (param.stack) {
                    output += "\n ".concat(param.stack);
                }
            }
            else {
                switch (type) {
                    case "string":
                    case "number":
                    case "boolean":
                        output = "".concat(param);
                        break;
                    case "undefined":
                        output = "undefined";
                        break;
                    case "function":
                        output = "[Function]";
                        break;
                    case "symbol":
                        output = "[Symbol] ".concat(param.toString());
                        break;
                    default:
                        output = "".concat((0, stringify_1.default)(param, undefined, 2));
                }
            }
            return output;
        }
    });
    /**
     * 格式化日志信息
     * @param level 日志等级
     * @param message 日志信息主体
     * @returns
     */
    Object.defineProperty(Logger.prototype, "_formatMessage", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (level, message) {
            // formatted timestamp
            var ts = Logger._getFormattedTime();
            var logLevel = "".concat(level).toUpperCase().padEnd(5, " ");
            return "".concat(ts, " ").concat(logLevel, " [").concat(this.ns || "default", "] - ").concat(message);
        }
    });
    /**
     * 发送日志到 SLS
     * @param log_level
     * @param content 日志内容
     * @param gp 日志全局属性
     * @param extendInfo 扩展信息
     */
    Object.defineProperty(Logger.prototype, "_sendToSLS", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (log_level, content, gp, extendInfo) {
            var _this = this;
            var _a;
            var args = {
                app_name: "".concat(this.ns || "default"),
                log_level: log_level,
                content: content,
                gp: gp,
                extendInfo: extendInfo || {},
            };
            if (!this.isDowngrade) {
                this.slsTracker.send(args);
                return;
            }
            (_a = this.isDowngrade) === null || _a === void 0 ? void 0 : _a.then(function (res) {
                if (res) {
                    _this.slsTracker.send(args);
                }
                else {
                    (0, base_log_1.baseLog)({
                        __topic__: _this.topic,
                        __source__: _this.source,
                        __logs__: [__assign({ app_name: args.app_name, log_level: args.log_level, content: args.content, gp: (0, utils_1.safeJSONStringify)(args.gp) }, args.extendInfo)],
                        __tags__: _this.tags,
                    });
                }
            });
        }
    });
    /**
     * 统一输出日志
     * @param level 日志等级
     * @param msgs
     */
    // TODO 支持不同的色块打印 log level
    Object.defineProperty(Logger.prototype, "_write", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (level) {
            var _this = this;
            var _a, _b, _c, _d, _e, _f;
            var msgs = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                msgs[_i - 1] = arguments[_i];
            }
            try {
                var stringifiedLog = msgs.map(function (m) { return _this._toString(m); }).join(" ");
                var content = this._formatMessage(level, stringifiedLog);
                var userId = (0, utils_1.getCookieUser)().userId;
                var gp = __assign(__assign({}, Logger.globalProps), { uuid: Logger._uuid, userId: "".concat(Logger._userId || userId), location: (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href, ua: (_b = window === null || window === void 0 ? void 0 : window.navigator) === null || _b === void 0 ? void 0 : _b.userAgent, screen: "".concat((_c = window.screen) === null || _c === void 0 ? void 0 : _c.width, "x").concat((_d = window.screen) === null || _d === void 0 ? void 0 : _d.height), screenWidth: "".concat((_e = window.screen) === null || _e === void 0 ? void 0 : _e.width), screenHeight: "".concat((_f = window.screen) === null || _f === void 0 ? void 0 : _f.height), network: (0, utils_1.getConnectionType)() || '', browser: (0, utils_1.getBrowserType)(), env: Logger.currentEnv, sdk: constant_1.version });
                if (Logger._shouldLogToConsole) {
                    console[level].apply(console, msgs);
                }
                // 补偿上报无需校验 level
                if (this.ns === "delayed_send" || Logger._checkIfLogLevelEnabled(level) || Logger._shouldLogToSls) {
                    // if (Logger._shouldLogToSls) {
                    this._sendToSLS(level, content, gp);
                    // }
                }
                else if (Logger._shouldLogToIndexedDB) {
                    // 日志等级不支持直接上报，如果定义了延迟上报，加入 indexDB
                    this.cacheTo.apply(this, __spreadArray([level], msgs, false));
                }
                // 最后检查一下是不是需要补偿上报
                this.delayedSend();
            }
            catch (e) {
                console.error("[MST-SLS-基础日志]：", e);
            }
        }
    });
    /**
     * 检查是否需要更新用户特定的 log level，主要是检索 extendConfig 里有没有用户级别的配置
     */
    Object.defineProperty(Logger, "_checkIfShouldUpdateUserSpecificLogLevel", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (!Logger._userId || !Logger._logExtendConfig) {
                return;
            }
            Logger._logLevels.some(function (level, index) {
                var userIds = Logger._logExtendConfig[level];
                if (userIds === null || userIds === void 0 ? void 0 : userIds.includes(Logger._userId)) {
                    // 找到了，设置用户特定的 log level
                    Logger.level = Logger._logLevels[index];
                    return true;
                }
                return false;
            });
        }
    });
    /**
     * 设置全局日志等级
     * @param level 日志等级
     * @param extendConfig
     */
    Object.defineProperty(Logger, "setGlobalLogLevel", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (level, extendConfig) {
            Logger.level = level;
            if (extendConfig && extendConfig.length > 0) {
                // 将服务端返回的字符串格式的配置转换为对象
                var extendConfigObj_1 = {};
                extendConfig.split(";").forEach(function (item) {
                    // item: DEBUG:1,2,3
                    var _a = item.split(":"), level = _a[0], userIdsInString = _a[1];
                    var userIds = userIdsInString.split(",");
                    if (userIds.length) {
                        extendConfigObj_1[level] = userIds;
                    }
                });
                Logger._logExtendConfig = extendConfigObj_1;
                Logger._checkIfShouldUpdateUserSpecificLogLevel();
            }
            // 追偿支持两种模式，全局以及 UserID
            // 1. 全局模式：调低全局的日志等级，此时所有用户的日志都会被追偿
            // 2. UserID 模式：只有指定的用户日志会被追偿，服务端下发方式为使用半角逗号分割的用户 ID 字符串
        }
    });
    /**
     * 设置用户 ID
     * @param userId 用户 ID
     * @returns
     */
    Object.defineProperty(Logger, "setUserId", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (userId) {
            Logger._userId = userId;
            Logger._checkIfShouldUpdateUserSpecificLogLevel();
        }
    });
    /**
     * 设置全局日志属性
     * @param globalProps 全局属性
     * @returns
     */
    Object.defineProperty(Logger, "setGlobalProps", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (globalProps) {
            Logger.globalProps = globalProps;
        }
    });
    /**
     * 输出日志，日志等级 info
     * @param args 日志内容
     */
    Object.defineProperty(Logger.prototype, "log", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            this._write.apply(this, __spreadArray([logger_1.LogLevel.log], args, false));
        }
    });
    /**
     * 普通信息日志
     * @param args 日志内容
     */
    Object.defineProperty(Logger.prototype, "info", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            this._write.apply(this, __spreadArray([logger_1.LogLevel.info], args, false));
        }
    });
    /**
     * 调试日志
     * @param args 日志内容
     */
    Object.defineProperty(Logger.prototype, "debug", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            this._write.apply(this, __spreadArray([logger_1.LogLevel.debug], args, false));
        }
    });
    /**
     * 警告日志
     * @param args 日志内容
     */
    Object.defineProperty(Logger.prototype, "warn", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            this._write.apply(this, __spreadArray([logger_1.LogLevel.warn], args, false));
        }
    });
    /**
     * 错误日志
     * @param msg
     */
    Object.defineProperty(Logger.prototype, "error", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (msg) {
            this._write(logger_1.LogLevel.error, msg);
        }
    });
    Object.defineProperty(Logger, "_logExtendConfig", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: {}
    });
    Object.defineProperty(Logger, "_logLevels", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: [
            logger_1.LogLevel.debug,
            logger_1.LogLevel.log,
            logger_1.LogLevel.info,
            logger_1.LogLevel.warn,
            logger_1.LogLevel.error,
        ]
    });
    Object.defineProperty(Logger, "_shouldLogToConsole", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Logger, "_shouldLogToSls", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Logger, "_shouldLogToIndexedDB", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Logger, "level", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: logger_1.LogLevel.info
    });
    Object.defineProperty(Logger, "globalProps", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: {}
    });
    Object.defineProperty(Logger, "currentEnv", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "production"
    });
    return Logger;
}());
exports.Logger = Logger;
